import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 33333 24494"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#1c1b17;stroke-width:952.381}.str1{stroke-width:362.857}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974338422352">
        <path
          d="M30736 476H2597c-1171 0-2121 950-2121 2121v6672h32381V2597c0-1171-949-2121-2121-2121zM476 13975c0 1172 950 2121 2121 2121h28139c1172 0 2121-949 2121-2121v-2879H476v2879z"
          className="stroke1"
          style={{
            fill: "none",
            strokeWidth: 952.381,
          }}
        />
        <path
          d="M17060 18875c105-217 15-479-202-585-218-105-479-14-585 203-746 1537-417 2340-127 3047 245 600 458 1118 105 2200-75 229 50 476 280 551 45 14 91 21 136 21 184 0 355-117 415-302 453-1386 131-2170-127-2801-263-642-471-1149 105-2334zM20711 18875c105-217 15-479-202-585-218-105-479-14-585 203-746 1537-417 2340-127 3047 245 600 457 1118 105 2200-75 229 50 476 280 551 45 14 91 21 136 21 184 0 355-117 415-302 453-1386 131-2170-127-2801-263-642-471-1149 105-2334zM24362 18875c105-217 15-479-203-585-217-105-479-14-584 203-746 1537-417 2340-127 3047 245 600 457 1118 104 2200-74 229 51 476 281 551 45 14 90 21 136 21 183 0 355-117 415-302 452-1386 131-2170-127-2801-263-642-471-1149 105-2334zM28012 18875c106-217 15-479-202-585-217-105-479-14-584 203-746 1537-418 2340-127 3047 245 600 457 1118 104 2200-74 229 51 476 280 551 46 14 91 21 136 21 184 0 356-117 416-302 452-1386 131-2170-127-2801-263-642-471-1149 104-2334zM6108 18875c106-217 15-479-202-585-217-105-479-14-585 203-746 1537-417 2340-127 3047 246 600 458 1118 105 2200-75 229 51 476 281 551 45 14 90 21 135 21 184 0 355-117 416-302 452-1386 130-2170-128-2801-263-642-470-1149 105-2334zM9759 18875c106-217 15-479-202-585-217-105-479-14-585 203-746 1537-417 2340-127 3047 245 600 458 1118 105 2200-75 229 50 476 280 551 45 14 91 21 136 21 184 0 355-117 415-302 453-1386 131-2170-127-2801-263-642-470-1149 105-2334zM13410 18875c105-217 15-479-202-585-218-105-479-14-585 203-746 1537-417 2340-127 3047 245 600 457 1118 105 2200-75 229 50 476 280 551 45 14 91 21 136 21 184 0 355-117 415-302 452-1386 131-2170-127-2801-263-642-471-1149 105-2334z"
          className="fil1 stroke1"
          style={{
            strokeWidth: 952.381,
          }}

        />
        <circle
          cx={3477}
          cy={3182}
          r={952}
          className="fil1"
          style={{
            // stroke: "#2b2a29",
            strokeWidth: 362.857,
          }}
        />
        <rect
          width={17480}
          height={1008}
          x={7927}
          y={13092}
          className="fil1"
          rx={9781}
          ry={15514}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
